import { useEffect } from 'react'
import { callAPI } from '../hooks/api'
import { useState } from 'react'
import Spinner from './Spinner'
import { base64ToBlobUrl } from '@/pages/pdf/_data/helper'

export default function WeatherHistory({ lat, lon, localAuth }) {
  const [loading, setLoading] = useState(true)
  const [weatherPlots, setWeatherPlots] = useState({})
  const [weatherText, setWeatherText] = useState('')

  async function fetchWeatherPlots(lat, lon) {
    // Create a new Date object for today
    const today = new Date()

    // Combine the year, month, and day components to form the yyyymmdd string
    const dts = `${today.getFullYear() - 11}0101`
    const dte = `${today.getFullYear() - 1}1231`

    var endpoint = '/get_weather_plots_from_pt'
    var params = {
      dts: dts,
      dte: dte,
      lat: lat,
      lon: lon,
      session_key: localAuth.sessionKey,
    }
    var res = await callAPI(endpoint, params)
    setLoading(false)
    if (res.status === 'success') {
      setWeatherPlots({
        ppt: res.plots.ppt,
        gdd: res.plots.gdd,
        tmax: res.plots.tmax,
        tmin: res.plots.tmin,
        cdd: res.plots.cdd,
        hdd: res.plots.hdd,
      })
      setWeatherText(res.text)
    }
  }

  useEffect(() => {
    if (Object.keys(weatherPlots).length === 0) fetchWeatherPlots(lat, lon)
  }, [])

  if (loading) {
    return <Spinner local={true} />
  }
  if (Object.keys(weatherPlots).length === 0)
    return <p className="ml-[30px] ">No Weather data for this parcel</p>
  else
    return (
      <div className="flex flex-col items-center justify-between">
        {Object.entries(weatherPlots).map(([plotName, url]) => (
          <div key={plotName} className="plot-container mb-5">
            <img src={base64ToBlobUrl(url)} alt={plotName} />
          </div>
        ))}
      </div>
    )
}
